export default "__VITE_ASSET__CLYs$laB__"